import { Injectable } from "@angular/core";
import { RestService } from "@stdoutsrl/design-kit";
import { api } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class DashboardService {
  constructor(private rest: RestService) {}

  getDashboard() {
    return this.rest.get(api.endpoint.dashboard);
  }

  getUserDashboard(code?: string) {
    return this.rest.get(
      api.endpoint.userDashboard + (code?.length ? `?code=${code}` : "")
    );
  }

  getUserDashboardLast5() {
    return this.rest.get(api.endpoint.userDashboardLast5);
  }

  getUserDashboardMost() {
    return this.rest.get(api.endpoint.userDashboardMostActive);
  }
}
